export const getTotal = ({ report, sheet, field }) => {
  return (
    report[sheet]
      ?.reduce((sum, obj) => {
        return sum + (parseFloat(obj[field]) || 0);
      }, 0)
      .toLocaleString("en-US") ?? ""
  );
};
